import styled from '@emotion/styled';

export const Wrapper = styled.div`
    padding-top: 30px;
    padding-bottom: 30px;
    @media screen and (min-width: 768px) {
        padding-top: 60px;
        padding-bottom: 60px;
    }
`;

export const TableWrapp = styled.div`
    h2 {
        text-align: center;
        text-transform: uppercase;
        padding: 8px 10px;
        color: var(--color-dark);
        font-size: 16px;
        background-color: var(--bc-hero);
        @media screen and (min-width: 768px) {
            font-size: 22px;
        }
    }
    h3 {
        padding: 5px 5px;
        color: var(--color-dark);
        font-size: 14px;
        background-color: hsla(32, 15%, 81%, 0.477);

        display: flex;
        align-items: center;
        gap: 5px;
        @media screen and (min-width: 768px) {
            font-size: 18px;
            padding: 5px 10px;
        }
    }
`;

export const TableStyled = styled.table`
    width: 100%;
    border-collapse: collapse;
    position: relative;
    margin-bottom: 44px;

    th, td {
        color: var(--color-brown);
        border-bottom: 1px solid #e0e0e0; 
        padding: 5px; 
        font-size: 12px;
        line-height: 1.4;
        text-align: end;
        @media screen and (min-width: 768px) {
            font-size: 16px;
            padding: 8px; 
        }
    }

    th:first-of-type {
        text-align: left;
    }
    td:first-of-type {
        width: 600px;
        text-align: left;
    }
    /* td:not(:first-of-type) {
        width: 60px;
    } */

    .discount {
        color: var(--color-red);
    }
`;

export const ButtonBox = styled.span`
    position: absolute;
    bottom: -42px;
    right: 0;
`;

export const Span = styled.span`
        display: flex;
        justify-content: flex-end; 
        align-items: center;
        text-align: center;
        gap: 4px;

        svg{
            font-size: 22px;
            color: var(--color-main-text);
        }
`;